/* eslint-disable no-unused-vars */
import './index.css';

const WuerthBold = require('../../../assets/fonts/WuerthBold.ttf');
const WuerthExtraBoldCond = require('../../../assets/fonts/WuerthExtraBoldCond.ttf');